export const serviceCatalogEn = {
  "areas": [
    {
      "id": "marketing",
      "label": "Marketing & growth",
      "headline": "Every side of marketing. Connected.",
      "intro": "We work across the core marketing disciplines: strategy, advertising, brand, e-commerce, traditional channels and digital analytics.\n\nWe determine where to appear, plan how to communicate and keep results in focus.",
      "categoryIds": [
        "M01",
        "M02",
        "M03",
        "M04",
        "M05",
        "M06",
        "M07",
        "M08"
      ],
      "cta": {
        "heading": "What would you like to change in marketing?",
        "text": "Let us identify the services your business needs, from strategy to execution.",
        "label": "Discuss your project"
      }
    },
    {
      "id": "ai",
      "label": "AI & automation",
      "headline": "AI connected to the way work gets done.",
      "intro": "We design AI and automation solutions for customer enquiries, sales reporting, document workflows and finance processes.\n\nNot every process needs AI. We analyse the work first, then determine where AI, conventional automation or human judgement belongs.",
      "categoryIds": [
        "A01",
        "A02",
        "A03",
        "A04",
        "A05",
        "A06",
        "A07",
        "A08"
      ],
      "cta": {
        "heading": "What could your business automate?",
        "text": "Let us assess your processes and systems to identify where AI or automation can help.",
        "label": "Discuss AI opportunities"
      }
    }
  ],
  "categories": [
    {
      "id": "M01",
      "title": "MARKETING STRATEGY & MANAGEMENT",
      "short": "Strategy",
      "intro": "We establish the direction before starting advertising.",
      "services": [
        {
          "id": "M01-01",
          "number": "01",
          "title": "Marketing strategy",
          "description": "We define the marketing direction around business objectives, the market and the target audience.",
          "icon": "Target",
          "iconConcept": "Strategic target."
        },
        {
          "id": "M01-02",
          "number": "02",
          "title": "Marketing audit and market research",
          "description": "We analyse current activity, competitors, audiences and market opportunities to inform decisions beyond assumptions.",
          "icon": "FileSearch",
          "iconConcept": "Magnifying glass over report."
        },
        {
          "id": "M01-03",
          "number": "03",
          "title": "Marketing planning and budgeting",
          "description": "We plan campaigns, channels, resources and budgets so the purpose and timing of each activity are clear.",
          "icon": "CalendarDays",
          "iconConcept": "Planning calendar."
        },
        {
          "id": "M01-04",
          "number": "04",
          "title": "Go-to-Market strategy",
          "description": "We develop positioning, communication and sales support plans for new products and services.",
          "icon": "Rocket",
          "iconConcept": "Product launch arrow."
        }
      ]
    },
    {
      "id": "M02",
      "title": "BRAND & COMMUNICATION",
      "short": "Brand",
      "intro": "We build brands to be remembered as well as recognised.",
      "services": [
        {
          "id": "M02-05",
          "number": "05",
          "title": "Brand strategy and positioning",
          "description": "We define the brand's audience, offer and differentiation from competitors.",
          "icon": "Fingerprint",
          "iconConcept": "Distinctive fingerprint."
        },
        {
          "id": "M02-06",
          "number": "06",
          "title": "Brand identity and architecture",
          "description": "We develop visual, verbal and structural identity and organise relationships between products and sub-brands.",
          "icon": "Shapes",
          "iconConcept": "Connected brand shapes."
        },
        {
          "id": "M02-07",
          "number": "07",
          "title": "Communication strategy",
          "description": "We plan what the brand should say, to whom, through which channels and in what tone.",
          "icon": "MessagesSquare",
          "iconConcept": "Speech bubbles with direction."
        },
        {
          "id": "M02-08",
          "number": "08",
          "title": "PR and reputation management",
          "description": "We plan public communications and media relations and support systematic reputation management.",
          "icon": "Newspaper",
          "iconConcept": "Newspaper and message."
        }
      ]
    },
    {
      "id": "M03",
      "title": "DIGITAL MARKETING",
      "short": "Digital",
      "intro": "Reaching the right audience matters more than simply being online.",
      "services": [
        {
          "id": "M03-09",
          "number": "09",
          "title": "Digital advertising campaigns",
          "description": "We develop, run and optimise advertising strategies and campaigns on Google, Meta and relevant digital platforms.",
          "icon": "Megaphone",
          "iconConcept": "Digital advertisement pointer."
        },
        {
          "id": "M03-10",
          "number": "10",
          "title": "Search engine optimisation — SEO",
          "description": "We improve technical performance, content and site structure to support search visibility.",
          "icon": "Search",
          "iconConcept": "Search result."
        },
        {
          "id": "M03-11",
          "number": "11",
          "title": "Social media marketing",
          "description": "We manage social strategy, content planning, channels, community communication and performance analysis.",
          "icon": "Share2",
          "iconConcept": "Social connection network."
        },
        {
          "id": "M03-12",
          "number": "12",
          "title": "Email and SMS marketing",
          "description": "We design campaigns, automated communication sequences and follow-up processes around the customer database.",
          "icon": "Mail",
          "iconConcept": "Envelope and notification."
        },
        {
          "id": "M03-13",
          "number": "13",
          "title": "Influencer and partnership marketing",
          "description": "We plan and manage campaigns with creators and partners suited to the brand.",
          "icon": "Users",
          "iconConcept": "Connected people."
        }
      ]
    },
    {
      "id": "M04",
      "title": "CREATIVE & CONTENT",
      "short": "Creative",
      "intro": "A good idea needs to communicate something as well as attract attention.",
      "services": [
        {
          "id": "M04-14",
          "number": "14",
          "title": "Creative strategy and campaign concepts",
          "description": "We develop advertising ideas, campaign concepts and creative directions aligned with brand objectives.",
          "icon": "Lightbulb",
          "iconConcept": "Idea bulb."
        },
        {
          "id": "M04-15",
          "number": "15",
          "title": "Content strategy and copywriting",
          "description": "We create copy, social content, advertising messages and communication plans in the brand's voice.",
          "icon": "PenLine",
          "iconConcept": "Editorial pen."
        },
        {
          "id": "M04-16",
          "number": "16",
          "title": "Graphic design and advertising materials",
          "description": "We develop visual communication and advertising materials for digital and print channels.",
          "icon": "PenTool",
          "iconConcept": "Design pen tool."
        },
        {
          "id": "M04-17",
          "number": "17",
          "title": "Creative management of photo and video production",
          "description": "We coordinate concepts, art direction and production with suitable partners.",
          "icon": "Clapperboard",
          "iconConcept": "Camera and film frame."
        }
      ]
    },
    {
      "id": "M05",
      "title": "TRADITIONAL MARKETING",
      "short": "Traditional",
      "intro": "Marketing extends beyond screens.",
      "services": [
        {
          "id": "M05-18",
          "number": "18",
          "title": "Television and radio advertising",
          "description": "We manage campaign strategy, media planning, advertising materials and placements for TV and radio.",
          "icon": "Tv",
          "iconConcept": "Television and radio signal."
        },
        {
          "id": "M05-19",
          "number": "19",
          "title": "Outdoor and OOH advertising",
          "description": "We plan and coordinate billboards, urban advertising and other out-of-home channels.",
          "icon": "PanelsTopLeft",
          "iconConcept": "Outdoor advertising panel."
        },
        {
          "id": "M05-20",
          "number": "20",
          "title": "Print advertising and media placements",
          "description": "We organise the production and placement of magazine, newspaper, catalogue, brochure and other print advertising.",
          "icon": "BookOpen",
          "iconConcept": "Printed publication."
        },
        {
          "id": "M05-21",
          "number": "21",
          "title": "Events and BTL marketing",
          "description": "We plan brand activations, launches, events, promotions and campaigns that reach audiences directly.",
          "icon": "Ticket",
          "iconConcept": "Event ticket."
        },
        {
          "id": "M05-22",
          "number": "22",
          "title": "Trade marketing and point-of-sale communication",
          "description": "We plan product presentation, promotional activity and marketing across retail channels.",
          "icon": "Store",
          "iconConcept": "Retail shelf."
        }
      ]
    },
    {
      "id": "M06",
      "title": "E-COMMERCE MARKETING",
      "short": "E-commerce",
      "intro": "The buying journey matters as much as page views.",
      "services": [
        {
          "id": "M06-23",
          "number": "23",
          "title": "E-commerce marketing strategy",
          "description": "We plan online sales channels, product presentation, acquisition and repeat purchases.",
          "icon": "ShoppingCart",
          "iconConcept": "Shopping cart with strategy lines."
        },
        {
          "id": "M06-24",
          "number": "24",
          "title": "Marketplace marketing",
          "description": "We manage product listings, visibility, advertising and sales support on suitable marketplaces.",
          "icon": "Store",
          "iconConcept": "Digital storefront."
        },
        {
          "id": "M06-25",
          "number": "25",
          "title": "Product catalogue and product page optimisation",
          "description": "We improve product names, descriptions, visuals, categories and pages to support purchase decisions.",
          "icon": "Package",
          "iconConcept": "Product package and detail sheet."
        },
        {
          "id": "M06-26",
          "number": "26",
          "title": "E-commerce advertising campaigns",
          "description": "We develop product advertising, remarketing and sales campaigns for online stores.",
          "icon": "ShoppingBag",
          "iconConcept": "Shopping bag with advertising arrow."
        },
        {
          "id": "M06-27",
          "number": "27",
          "title": "E-commerce conversion optimisation",
          "description": "We analyse the purchase journey from product page to payment, identify obstacles and propose improvements.",
          "icon": "MousePointerClick",
          "iconConcept": "Checkout conversion path."
        },
        {
          "id": "M06-28",
          "number": "28",
          "title": "Repeat sales and customer loyalty",
          "description": "We use customer data to plan repeat-purchase campaigns, loyalty mechanisms and personalised communications.",
          "icon": "RefreshCcw",
          "iconConcept": "Circular shopping arrows."
        }
      ]
    },
    {
      "id": "M07",
      "title": "B2B MARKETING & GROWTH",
      "short": "B2B Growth",
      "intro": "Every enquiry is different. Decisions take time.",
      "services": [
        {
          "id": "M07-29",
          "number": "29",
          "title": "B2B marketing strategy",
          "description": "We develop audience, communication, channel and acquisition strategies suited to business-to-business sales.",
          "icon": "Building2",
          "iconConcept": "Connected organizations."
        },
        {
          "id": "M07-30",
          "number": "30",
          "title": "Lead generation and lead nurturing",
          "description": "We build processes to attract and qualify potential customers and maintain contact until they are ready for sales.",
          "icon": "ListFilter",
          "iconConcept": "Lead funnel."
        },
        {
          "id": "M07-31",
          "number": "31",
          "title": "Account-Based Marketing — ABM",
          "description": "We plan personalised B2B campaigns for selected companies and decision-makers.",
          "icon": "Target",
          "iconConcept": "Targeted company account."
        },
        {
          "id": "M07-32",
          "number": "32",
          "title": "Marketing and sales alignment",
          "description": "We connect lead handover, tracking and joint evaluation between marketing and sales teams.",
          "icon": "GitMerge",
          "iconConcept": "Interlocking arrows."
        }
      ]
    },
    {
      "id": "M08",
      "title": "MARKETING ANALYTICS & CUSTOMER EXPERIENCE",
      "short": "Analytics",
      "intro": "Numbers become useful when we ask the right questions.",
      "services": [
        {
          "id": "M08-33",
          "number": "33",
          "title": "Marketing analytics and reporting",
          "description": "We build reporting systems that analyse campaign performance, costs, enquiries and relevant commercial metrics.",
          "icon": "ChartNoAxesCombined",
          "iconConcept": "Analytics chart."
        },
        {
          "id": "M08-34",
          "number": "34",
          "title": "CRM and customer database management",
          "description": "We plan CRM strategy, customer data structures, segmentation and links to marketing communications.",
          "icon": "Database",
          "iconConcept": "Customer database."
        },
        {
          "id": "M08-35",
          "number": "35",
          "title": "Customer experience and customer journey",
          "description": "We analyse the journey from first contact to purchase and beyond, identifying opportunities for improvement.",
          "icon": "Route",
          "iconConcept": "Customer journey route."
        },
        {
          "id": "M08-36",
          "number": "36",
          "title": "Websites, landing pages and conversion optimisation",
          "description": "We plan marketing websites and landing pages and improve the user experience and enquiry process.",
          "icon": "AppWindow",
          "iconConcept": "Browser window with cursor."
        },
        {
          "id": "M08-37",
          "number": "37",
          "title": "Marketing experiments and growth optimisation",
          "description": "We test messages, audiences, channels and user experience variants to improve decisions using measurable results.",
          "icon": "FlaskConical",
          "iconConcept": "Split-test experiment."
        }
      ]
    },
    {
      "id": "A01",
      "title": "AI SALES & REVENUE",
      "short": "AI Sales",
      "intro": "An enquiry is the beginning. The system must support what follows.",
      "services": [
        {
          "id": "A01-01",
          "number": "01",
          "title": "AI Lead-to-Sale Engine",
          "description": "A system designed to collect and classify enquiries from websites, messaging channels and forms, pass them to CRM and route them to sales staff.",
          "icon": "MessageSquareText",
          "iconConcept": "Incoming message connected to CRM."
        },
        {
          "id": "A01-02",
          "number": "02",
          "title": "AI Deal Recovery Agent",
          "description": "A solution designed to identify delayed follow-ups and stalled CRM opportunities, suggest next steps and automate approved contact processes.",
          "icon": "RefreshCcw",
          "iconConcept": "Sales opportunity with follow-up reminder."
        },
        {
          "id": "A01-03",
          "number": "03",
          "title": "AI Sales Conversation Intelligence",
          "description": "A system designed to analyse authorised sales conversations and identify objections, recurring questions and opportunities to improve sales processes.",
          "icon": "MessagesSquare",
          "iconConcept": "Conversation with analytical markers."
        },
        {
          "id": "A01-04",
          "number": "04",
          "title": "AI Proposal & Tender Assistant",
          "description": "An AI assistant designed to draft proposals and tender responses using customer requirements and approved company information.",
          "icon": "FileText",
          "iconConcept": "Structured proposal document."
        },
        {
          "id": "A01-05",
          "number": "05",
          "title": "AI Revenue Forecasting",
          "description": "An analytical solution designed to develop revenue scenarios from historical sales and CRM data and highlight potential sales risks.",
          "icon": "TrendingUp",
          "iconConcept": "Revenue forecast chart."
        }
      ]
    },
    {
      "id": "A02",
      "title": "AI MARKETING & GROWTH",
      "short": "AI Marketing",
      "intro": "Marketing results need understanding, not just collection.",
      "services": [
        {
          "id": "A02-06",
          "number": "06",
          "title": "AI Marketing Intelligence Center",
          "description": "A system designed to combine advertising, web analytics and CRM data for connected analysis of marketing and sales performance.",
          "icon": "ChartNoAxesCombined",
          "iconConcept": "Connected marketing data sources."
        },
        {
          "id": "A02-07",
          "number": "07",
          "title": "AI Campaign Performance Analyst",
          "description": "A solution designed to detect unusual campaign changes, analyse performance and prepare optimisation recommendations.",
          "icon": "ChartLine",
          "iconConcept": "Campaign chart with anomaly marker."
        },
        {
          "id": "A02-08",
          "number": "08",
          "title": "AI Creative Intelligence",
          "description": "A system designed to compare creative performance, analyse effective messages and formats and support new creative briefs.",
          "icon": "Lightbulb",
          "iconConcept": "Creative layout with analysis annotation."
        },
        {
          "id": "A02-09",
          "number": "09",
          "title": "AI Customer Segmentation Engine",
          "description": "A solution designed to segment customers using purchase and behavioural data and support more relevant communication planning.",
          "icon": "Users",
          "iconConcept": "Segmented customer groups."
        },
        {
          "id": "A02-10",
          "number": "10",
          "title": "AI Competitor & Market Intelligence",
          "description": "A system designed to collect and analyse public information about competitors and market changes and prepare structured summaries.",
          "icon": "Search",
          "iconConcept": "Market intelligence search."
        }
      ]
    },
    {
      "id": "A03",
      "title": "AI FINANCE & CFO",
      "short": "AI Finance",
      "intro": "Timely financial visibility supports better decisions.",
      "services": [
        {
          "id": "A03-11",
          "number": "11",
          "title": "AI CFO Copilot",
          "description": "An AI system designed to analyse financial data, support management reporting and explain key indicators.",
          "icon": "Wallet",
          "iconConcept": "Financial report with analytical assistant."
        },
        {
          "id": "A03-12",
          "number": "12",
          "title": "AI Invoice Processing",
          "description": "An automation solution designed to extract invoice data, support consistency checks and route documents for approval.",
          "icon": "Receipt",
          "iconConcept": "Invoice with verified fields."
        },
        {
          "id": "A03-13",
          "number": "13",
          "title": "AI Receivables & Collection Agent",
          "description": "A system designed to track receivables and due dates, identify delays and automate approved payment reminders.",
          "icon": "CalendarDays",
          "iconConcept": "Payment calendar and reminder."
        },
        {
          "id": "A03-14",
          "number": "14",
          "title": "AI Cash Flow Forecasting",
          "description": "A solution designed to estimate cash flow scenarios from financial data and support liquidity risk assessment.",
          "icon": "ChartLine",
          "iconConcept": "Cash flow projection."
        },
        {
          "id": "A03-15",
          "number": "15",
          "title": "AI Margin & Cost Intelligence",
          "description": "A system designed to analyse costs, margins and profitability across products, services and operations to support decisions.",
          "icon": "Scale",
          "iconConcept": "Cost and margin comparison."
        }
      ]
    },
    {
      "id": "A04",
      "title": "AI CUSTOMER EXPERIENCE",
      "short": "AI Customer Experience",
      "intro": "Every enquiry is new to the customer, even when the process repeats.",
      "services": [
        {
          "id": "A04-16",
          "number": "16",
          "title": "AI Omnichannel Service Agent",
          "description": "An AI system designed to answer queries across integrated messaging and support channels, route requests and hand over to staff when needed.",
          "icon": "Headphones",
          "iconConcept": "Connected customer communication channels."
        },
        {
          "id": "A04-17",
          "number": "17",
          "title": "AI Voice Receptionist",
          "description": "A voice AI solution designed to handle calls using defined scenarios, receive enquiries, support appointment processes and route callers to operators.",
          "icon": "PhoneCall",
          "iconConcept": "Telephone handset with voice lines."
        },
        {
          "id": "A04-18",
          "number": "18",
          "title": "AI Customer Retention Engine",
          "description": "A system designed to analyse customer behaviour, identify weakening relationships and support suitable re-engagement campaigns.",
          "icon": "RefreshCcw",
          "iconConcept": "Returning customer arrow."
        },
        {
          "id": "A04-19",
          "number": "19",
          "title": "AI Voice of Customer Analytics",
          "description": "A solution designed to analyse reviews, complaints and feedback to identify recurring problems and service improvements.",
          "icon": "MessageSquareText",
          "iconConcept": "Feedback speech bubble with analysis."
        }
      ]
    },
    {
      "id": "A05",
      "title": "AI OPERATIONS & WORKFLOW AUTOMATION",
      "short": "AI Operations",
      "intro": "Recurring work does not always need manual effort.",
      "services": [
        {
          "id": "A05-20",
          "number": "20",
          "title": "AI Document Workflow Automation",
          "description": "A system designed to extract and classify document data and route it through defined review and approval stages.",
          "icon": "Files",
          "iconConcept": "Document workflow."
        },
        {
          "id": "A05-21",
          "number": "21",
          "title": "AI Internal Knowledge Assistant",
          "description": "An AI assistant designed to help staff find sourced answers in authorised internal documents and knowledge bases.",
          "icon": "BookOpen",
          "iconConcept": "Search within knowledge books."
        },
        {
          "id": "A05-22",
          "number": "22",
          "title": "AI Project Operations Agent",
          "description": "A system designed to track project tasks, deadlines and progress, flag delays and prepare management summaries.",
          "icon": "ListTodo",
          "iconConcept": "Task timeline with status markers."
        },
        {
          "id": "A05-23",
          "number": "23",
          "title": "AI IT Helpdesk Agent",
          "description": "An AI system designed to classify internal technical requests, create support tickets and provide relevant troubleshooting guidance.",
          "icon": "Headset",
          "iconConcept": "Technical support ticket."
        }
      ]
    },
    {
      "id": "A06",
      "title": "AI HR & PEOPLE OPERATIONS",
      "short": "AI HR",
      "intro": "HR teams need time beyond document tracking.",
      "services": [
        {
          "id": "A06-24",
          "number": "24",
          "title": "AI Recruitment Operations",
          "description": "AI support for collecting applications, structuring candidate information and coordinating recruitment administration.",
          "icon": "UserRoundSearch",
          "iconConcept": "Candidate file and checklist."
        },
        {
          "id": "A06-25",
          "number": "25",
          "title": "AI Employee Onboarding",
          "description": "An automation system designed to connect new employee documents, orientation materials, tasks and onboarding stages.",
          "icon": "ClipboardList",
          "iconConcept": "New employee onboarding checklist."
        },
        {
          "id": "A06-26",
          "number": "26",
          "title": "AI Learning & Training Assistant",
          "description": "An AI assistant designed to support employee learning using internal training materials and approved knowledge sources.",
          "icon": "GraduationCap",
          "iconConcept": "Open learning book with search."
        }
      ]
    },
    {
      "id": "A07",
      "title": "AI PROCUREMENT & SUPPLY CHAIN",
      "short": "AI Procurement",
      "intro": "Procurement decisions need context as well as prices.",
      "services": [
        {
          "id": "A07-27",
          "number": "27",
          "title": "AI Supplier Comparison",
          "description": "An AI solution designed to structure and compare supplier quotations using prices, terms and defined criteria.",
          "icon": "GitCompare",
          "iconConcept": "Side-by-side supplier quotations."
        },
        {
          "id": "A07-28",
          "number": "28",
          "title": "AI Inventory & Demand Forecasting",
          "description": "A system designed to develop demand scenarios from historical sales, stock and demand data and support inventory planning.",
          "icon": "Boxes",
          "iconConcept": "Inventory boxes and forecast line."
        },
        {
          "id": "A07-29",
          "number": "29",
          "title": "AI Purchase Approval Workflow",
          "description": "An automation solution designed to route purchase requests according to budget limits, authority rules and approval stages.",
          "icon": "CheckCheck",
          "iconConcept": "Purchase request with approval check."
        }
      ]
    },
    {
      "id": "A08",
      "title": "AI EXECUTIVE INTELLIGENCE",
      "short": "AI Executive",
      "intro": "Leaders need a clearer view, not simply more reports.",
      "services": [
        {
          "id": "A08-30",
          "number": "30",
          "title": "AI CEO Command Center",
          "description": "A solution designed to connect sales, marketing, finance and operations data in one management view of business performance.",
          "icon": "LayoutDashboard",
          "iconConcept": "Integrated executive overview."
        },
        {
          "id": "A08-31",
          "number": "31",
          "title": "AI Executive Reporting Agent",
          "description": "An AI system designed to collect departmental and system data and prepare periodic executive reports and summaries of key changes.",
          "icon": "FileBarChart",
          "iconConcept": "Consolidated executive report."
        },
        {
          "id": "A08-32",
          "number": "32",
          "title": "AI Business Scenario Intelligence",
          "description": "An analytical solution designed to model alternative business decisions using available data and stated assumptions and compare possible effects.",
          "icon": "GitBranch",
          "iconConcept": "Branching business scenarios."
        }
      ]
    }
  ],
  "footer": {
    "heading": "Understand the problem before choosing a service.",
    "text": "Sometimes one service is enough. Sometimes several processes need to work together. We determine the right approach around your business needs.",
    "label": "Contact YUXEL"
  }
};
